// To handle chunk load fail when deploy new release but user hasn't reload
export function componentLoader(lazyComponent, attemptsLeft) {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        // let us retry after 1 second
        setTimeout(() => {
          if (attemptsLeft === 1) {
            // Guard against infinite reload loops: only reload once per session
            const reloadKey = 'chunk_load_reloaded';
            const alreadyReloaded = sessionStorage.getItem(reloadKey);
            if (!alreadyReloaded) {
              sessionStorage.setItem(reloadKey, '1');
              window.location.reload();
            } else {
              sessionStorage.removeItem(reloadKey);
              reject(error);
            }
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1).then(resolve, reject);
        }, 1000);
      });
  });
}
